export default "__VITE_ASSET__DIeGocZS__"